import css_9hd35pzxlfw from './css/MenuButton.css';
import Div from './Div.js';

const css = css_9hd35pzxlfw;

export default class MenuButton extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		// this.element.addEventListener
		// (
		// 	'click',
		// 	() =>
		// 	{
		// 		config.player.element.classList.toggle('paused');
		// 	}
		// )
	}
	get cssText()
	{
		return css;
	}
}